<script>
  import Card from '../../components/card.svelte'
  import StatCell from './stat_cell.svelte'

  let { attention = {}, queue = {}, total = 0 } = $props()

  const tiles = $derived(
    [
      queue.quest_submissions && {
        key: 'overdue-submissions',
        value: queue.quest_submissions.overdue_count,
        label: 'Submissions waiting 1d+',
        href: '/quest-submissions?mode=pending&sort=oldest'
      },
      queue.moment_reviews && {
        key: 'overdue-moments',
        value: queue.moment_reviews.overdue_count,
        label: 'Moment reports waiting 1d+',
        href: '/moments?mode=flagged'
      },
      queue.user_reviews && {
        key: 'overdue-users',
        value: queue.user_reviews.overdue_count,
        label: 'User reports waiting 1d+',
        href: '/user-reports?mode=needs_review'
      },
      attention.social && {
        key: 'hidden',
        value: attention.social.hidden_moments_pending,
        label: 'Auto-hidden, unreviewed',
        title: 'Moments hidden by 2+ reports and still awaiting review',
        href: '/moments?mode=hidden'
      },
      attention.social && {
        key: 'icons',
        value: attention.social.icon_cleared_users_pending,
        label: 'Icons auto-cleared',
        title: 'Users whose profile icon was auto-cleared and still have pending reports',
        href: '/user-reports?mode=needs_review'
      },
      attention.quests && {
        key: 'uploads',
        value: attention.quests.failed_uploads_last_hour,
        label: 'Failed uploads, last hour',
        href: '/media-uploads'
      }
    ].filter(Boolean)
  )

</script>

<Card title="Needs attention">
  {#snippet actions()}
    <span class="text-sm text-base-content/60">{total === 0 ? 'All clear' : `${total} item${total === 1 ? '' : 's'}`}</span>
  {/snippet}
  <div class="grid grid-cols-2 gap-2">
    {#each tiles as tile (tile.key)}
      <StatCell value={tile.value} label={tile.label} title={tile.title} href={tile.href} highlight={tile.value > 0} />
    {/each}
  </div>
</Card>
